// Shared brand metadata used across the brand selection, login, and layout screens.
export const BRANDS = {
  garhwalhikes: { key: 'garhwalhikes', name: 'Garhwal Hikes', icon: '🏔️', tagline: 'Trekking & Pilgrimage Tours | Garhwal Himalayas' },
  yatrayatri: { key: 'yatrayatri', name: 'YatraYatri', icon: '🧭', tagline: 'Trek · Explore · Discover' }
};

export function getBrand(key) {
  return BRANDS[key] || BRANDS.garhwalhikes;
}

export function getSelectedBrand() {
  const stored = localStorage.getItem('gh_brand');
  return stored === 'yatrayatri' ? 'yatrayatri' : stored === 'garhwalhikes' ? 'garhwalhikes' : null;
}

export function setSelectedBrand(brand) {
  localStorage.setItem('gh_brand', brand);
}

export function clearSelectedBrand() {
  localStorage.removeItem('gh_brand');
}
